/**
 * Styles for the KBar search modal and positioner.
 *
 * Note: These use plain JS objects (not MUI SxProps) because kbar
 * components use native `style` props, not MUI `sx`.
 */

export const kbarProviderStyles = {
  searchModal: (theme, isVisible) => ({
    maxWidth: '800px',
    width: '100%',
    height: '70vh',
    background: theme.palette.background?.paper,
    color: theme.palette.text?.primary,
    borderRadius: '12px',
    overflow: 'hidden',
    boxShadow: theme.shadows?.[6],
    border: `1px solid ${theme.palette.divider}`,
    display: 'flex',
    flexDirection: 'column',
    opacity: isVisible ? 1 : 0,
    transform: isVisible ? 'scale(1)' : 'scale(0.98)',
    transition: 'opacity 0.15s ease, transform 0.15s ease',
  }),

  searchContent: {
    flex: 1,
    minHeight: 0,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    padding: '0 16px 16px',
  },

  positioner: (theme) => ({
    position: 'fixed',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'center',
    width: '100vw',
    inset: '0px',
    padding: window.innerWidth < 600 ? '8vh 16px 16px' : '14vh 16px 16px',
    background: theme.palette.mode === 'dark' ? 'rgba(0, 0, 0, 0.8)' : 'rgba(0, 0, 0, 0.6)',
    boxSizing: 'border-box',
    zIndex: 9999,
  }),
}
